import get from 'lodash/get';
import types from '../types';
import getErrorMessage from '../utils/getErrorMessage';
import { showToast } from './Toast';

const formatDate = date => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getCampaignWidgets = payload => {
  const today = new Date();
  const twoYearsAgo = new Date();
  twoYearsAgo.setFullYear(today.getFullYear() - 2);
  return {
    type: types.api.FETCH_NUDGE,
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      queryParams: { campaign: payload.campaign, qid: payload.hotelId, page_type: payload.pageType},
      method: 'POST',
      body:
        payload.pageType === 'filter'
          ? {
              hotelId: payload.hotelId,
              required_fields: ['room_type', 'room_number', 'topics_filter', 'city', 'state', 'brand'],
              supplyFilterKeys: ['property_id'],
              filters: {
                start_date: formatDate(twoYearsAgo),
                end_date: formatDate(today)
              }
            }
          : {
              hotelId: payload.hotelId,
              required_fields: ['room_type', 'room_number', 'topics_filter', 'city', 'state'],
              supplyFilterKeys: ['property_id']
            }
    },
    onSuccess: ({ data }) => {
      const response = get(data, 'data', {});
      payload.onSuccess(response);
    },
    onError: ({ error, store }) => {
      store.dispatch(showToast({ message: getErrorMessage(error) }));
      payload.onError();
    }
  };
};

export default getCampaignWidgets;
